import * as React from "react";
import Autocomplete, {
  AutocompleteInputChangeReason,
} from "@mui/material/Autocomplete";
import {
  Box,
} from "@mui/material";
import { useRef, useState } from "react";

import FormInputFieldIcon from "./FormInputFieldIcon";
import {
  FaSearchIcon,
} from "./styles/style";
import { handleInputEvent } from "../../utils";
import { ServiceProviderPayload } from "../../models/Api/User";

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef<HTMLDivElement>((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <Box ref={ref} {...props} {...outerProps} />;
});
OuterElementType.displayName = "Search";

export interface ListOptionsData {
  options: any[];
  open: boolean;
  value: string| ServiceProviderPayload | null;
  setOpen: (value: boolean) => void;
  handleInputChange?: (
    event: React.SyntheticEvent<Element, Event>,
    value: string,
    reason: AutocompleteInputChangeReason
  ) => void;
  sx?: any;
  handleSelect?: any;
  autocompleteInputIcon?: any;
  maxLength?: number;
  width?: string;
  loading?: boolean;
  placeholder?: string;
  InputType?: string;
  handleFocus?: any;
  injectedTo?: string;
  hideCrossIcon?: boolean;
  setClearBlur?: boolean;
}

const VirtualizeAutocomplete: React.FC<ListOptionsData> = ({
  handleInputChange,
  sx,
  open,
  setOpen,
  autocompleteInputIcon,
  maxLength,
  placeholder,
  value,
  InputType,
  handleFocus,
  injectedTo,
  hideCrossIcon,
  setClearBlur,
  options
}: ListOptionsData) => {
  React.useEffect(() => {
    window.addEventListener("scroll", closeDropdown);
    return () => {
      window.removeEventListener("scroll", closeDropdown);
    };
  }, []);

  const [resetInputValue, setResetInputValue] = useState<boolean>(false);
  const inputRef = useRef<any>(null);

  React.useEffect(() => {
    if (resetInputValue) {
      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  }, [resetInputValue]);

  const closeDropdown = () => {
    setOpen(false);
  };

  const handleChange = () => {
    setResetInputValue(true);
  };

  return (
    <Autocomplete
      options={options}
      id="virtualize-autocomplete"
      value={value}
      freeSolo
      sx={sx}
      open={open }
      onChange={handleChange}
      onClose={() => setOpen(false)}
      clearOnBlur={!setClearBlur ? false : true}
      onBlur={() => setOpen(false)}
      data-testid={injectedTo}
      onInputChange={(event, value, reason) => {
        setResetInputValue(false);
        handleInputChange && handleInputChange(event, value, reason);
      }}
      onInput={(e) => {
        handleInputEvent(e, InputType);
      }}
      onFocus={handleFocus}
      filterOptions={(options) => options}
      renderOption={(props, option) => [props, option] as React.ReactNode}
      renderGroup={(params) => params as unknown as React.ReactNode}
      renderInput={(params) => {
        params.inputProps.maxLength = maxLength;
        return (
          <FormInputFieldIcon
            iconStart={autocompleteInputIcon}
            secondIcon={<FaSearchIcon />}
            {...params}
            placeholder={placeholder}
            elementRef={inputRef}
            hideCrossIcon={hideCrossIcon}
          />
        );
      }}
      forcePopupIcon={false}
    />
  );
};
export default VirtualizeAutocomplete;
